module.exports = __webpack_public_path__ + "static/media/palladium-hover.c0388d8a.png";